import React, { useEffect, useMemo, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { ArrowLeftIcon, XMarkIcon } from "@heroicons/react/24/outline";
import ShopCartExpiredItemsList from "./finishedListCard";
// import { resubmitArchivedItem, editresubmitArchivedItem ,deleteProductItem} from '../../redux/reducer/shopCartReducer';
import PopupModal from "../sharedComponents/customPopUp"; // Import the PopupModal
import EditItemModal from "./editFinishedtems";
import { useTranslation } from "react-i18next";
import BoxEmpty from "../boxDetials/boxEmpty";
import {
  deleteProductItem,
  getProductItemById,
  updateProductItem,
} from "../../redux/reducer/productReducer";
import {
  deleteCart,
  fetchMyCarts,
  resendCart,
} from "../../redux/reducer/cartReducer";
import CustomBuyForMeCard from "../buyForMe/customBuyForMeCard";
import CustomBuyForMeButtonOrders from "../ordersForBuyForMe/customOrderBuyButton";
import LoadingSpinner from "../animation/LoadingSpinner";
import { getCurrencyAndLanguageSymbol } from "../../constent/currencyUtils";
import useLanguageDirection from "../../hooks/useLanguageDirection";

const FinishedOrders = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  // const [editItem, setEditItem] = useState(null); // Item data to edit
  const { carts, cartsLoading, cartsError } = useSelector(
    (state) => state.carts
  );
  const [formData, setFormData] = useState({ additionalInfo: "", count: "" });
  const [editingItem, setEditingItem] = useState(null);
  const direction = useLanguageDirection();

  const currencySymbol = getCurrencyAndLanguageSymbol();

  useEffect(() => {
    dispatch(fetchMyCarts());
  }, [dispatch]);

  const isCartSource = Array.isArray(carts)
    ? carts.filter((cart) => ["expired"].includes(cart.status))
    : null;

  const roundToTwo = (num) => parseFloat(Number(num).toFixed(2));

  const handleDeleteCart = (cartId) => {
    try {
      // console.log(cartId)
      dispatch(deleteCart(cartId))
        .unwrap()
        .then(() => dispatch(fetchMyCarts()));
    } catch (err) {
      console.error("Error:", err);
    }
  };

  // Handle Resend Cart Function
  const handleResendCart = (cartId) => {
    try {
      // console.log(cartId)
      dispatch(resendCart(cartId))
        .unwrap()
        .then(() => dispatch(fetchMyCarts()));
    } catch (err) {
      console.error("Error:", err);
    }
  };

  // Handle Delete Function
  const handleDelete = (itemId) => {
    if (window.confirm(t("youWantDelete"))) {
      dispatch(deleteProductItem(itemId))
        .unwrap()
        .then(() => alert(t("ItemDeleted")))
        .catch((error) => alert(error || t("FailedDeleteItem")));
    }
  };

  const openEditForm = (item) => {
    // console.log(item)
    setFormData({
      // productLink: item.productLink || "",
      // additionalInfo: item.additionalInfo || "",
      count: item.count || "1",
    });
    setEditingItem(item);
  };

  const handleSubmitEdit = (e) => {
    e.preventDefault();

    // console.log("Submitting formData: ", formData); // ✅ Check what's inside

    const updatedData = {
      // productLink: formData.productLink,
      // additionalInfo: formData.additionalInfo,
      count: formData.count,
    };

    // console.log(allProducts)
    dispatch(updateProductItem({ itemId: editingItem._id, data: updatedData }))
      .unwrap()
      .then(() => {
        dispatch(getProductItemById());
        dispatch(fetchMyCarts());
        alert(t("ProductUpdated"));
        setEditingItem(null);
      })
      .catch((error) => {
        console.error(error);
        alert(t("FailedUpdateItem"));
      });
  };

  // console.log(isCartSource)
  // console.log(carts)

  if (cartsLoading) {
    return <LoadingSpinner />;
  }

  if (carts.length === 0 || isCartSource.length === 0 || cartsError) {
    return <BoxEmpty title="EmptyExpirBox" />;
  }
  // if(!expiredItems || expiredItems.length === 0) return <BoxEmpty title="completedShipping"/>
  return (
    <div className="w-full space-y-6 lg:px-6">
      {/* Displaying the list of expired items */}
      {isCartSource.map((cart) => (
        <div key={cart._id}>
          <div className="grid grid-cols-2 gap-2 lg:gap-4 lg:grid-cols-3">
            {cart?.products.map((product) => (
              <CustomBuyForMeCard
                key={product._id}
                image={
                  product.img || "https://api.markaship.com/uploads/waiting.png"
                }
                title={
                  product.name === "Waiting..."
                    ? { en: "Waiting...", ar: "انتظر..." }
                    : product.name
                }
                size={product.additionalInfo || "N/A"}
                link={product.link}
                count={product.count || "1"}
                price={
                  roundToTwo(
                    Number(product.price) * Number(product.count) + Number(product.DShippingFees)
                  ) || "0.00"
                }
                status={product.status || "pending"}
                timeLeft={product.timeLeft || "0"}
                isEditable={true}
                del={() => handleDelete(product._id)}
                onEdit={() => openEditForm(product)}
              />
            ))}
          </div>

          {/* Cart Info (outside grid) */}
          <div className="flex gap-4">
            <div className="w-full mt-4 ">
              <span className="mb-2 text-sm font-medium text-gray-500 lg:text-base">
                {t("status")}
              </span>
              <div className="p-2 mt-2 bg-white border rounded-md lg:p-4">
                <span className="text-xs font-bold text-black lg:text-lg">
                  {t(`${cart?.status}`)}
                </span>
              </div>
            </div>

            <div className="w-full mt-4">
              <span className="mb-2 text-sm font-medium text-gray-500 lg:text-base">
                {t("final_total")}
              </span>
              <div className="p-2 mt-2 bg-white border rounded-md lg:p-4">
                <span className="text-xs font-bold text-black lg:text-xl">
                  {roundToTwo(Number(cart.totalCartPrice))}{" "}
                  <span className="text-[9px] lg:text-xs">
                    {" "}
                    {currencySymbol}
                  </span>
                </span>
              </div>
            </div>
          </div>
          <div className="flex justify-between">
            <CustomBuyForMeButtonOrders
              children={t("Resend")}
              icon={ArrowLeftIcon}
              bgColor="bg-custom-yellow"
              textColor="text-black"
              iconColor="text-black"
              onClick={() => handleResendCart(cart._id)}
              direction={direction}
            />
            <CustomBuyForMeButtonOrders
              children={t("CancelShipment")}
              icon={ArrowLeftIcon}
              bgColor="bg-red-600"
              textColor="text-white"
              iconColor="text-white"
              onClick={() => handleDeleteCart(cart._id)}
              direction={direction}
            />
          </div>
        </div>
      ))}

      {/* Edit Item Modal */}

      {editingItem && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30 bg-black/50"
          dir={direction}
        >
          <div className="w-full max-w-lg p-6 mx-4 bg-white rounded-lg shadow-xl md:mx-0">
            <div className="flex justify-between mb-4">
              <h2 className="text-lg font-bold text-black">
                {t("EditProduct")}
              </h2>
              <button onClick={() => setEditingItem(null)}>
                <XMarkIcon className="w-6 h-6 text-black" />
              </button>
            </div>
            <form onSubmit={handleSubmitEdit} className="flex flex-col gap-4">
              <div>
                <label className="text-sm text-black">
                  {t("ProductCount")}
                </label>
                <input
                  type="number"
                  className="w-full px-4 py-2 text-black bg-gray-100 border rounded"
                  value={formData.count}
                  onChange={(e) =>
                    setFormData({ ...formData, count: e.target.value })
                  }
                />
              </div>
              <button
                type="submit"
                className="px-4 py-2 mt-2 font-bold text-black duration-300 rounded bg-custom-yellow hover:bg-black hover:text-white"
              >
                {t("Update")}
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default FinishedOrders;
